export const PERMISSIONS_KEY = "permissions";
